import(/* webpackMode: "eager" */ "/vercel/path1/app/(core)/register/layout.tsx");
